/**
 * 涨跌幅颜色变化
 */

function Color() {}

/**
 * @param {number || string} num
 */
Color.getColor = function (num) {
  if (typeof num === 'number' || typeof num === 'string') {
    num = parseFloat(num);

    if (num > 0) {
      return '#c73128';
    } else if (num < 0) {
      return '#3e9478';
    } else {
      return '#333333';
    }
  } else {
    return '#333333';
  }
};

export default Color;



// WEBPACK FOOTER //
// ./src/utils/color.js